// src/App.js
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Home from "./pages/Home";
import Projects from "./pages/Projects";
// import Other from "./pages/Other"; // Uncomment when ready to add the Other page back

function App() {
  return (
    <div className="relative min-h-screen flex flex-col bg-gradient-to-b from-orange-50 to-orange-200">
      <Router>
        <div className="absolute top-0 right-0 p-6 z-50">
          <Header />
        </div>

        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/projects" element={<Projects />} />
            {/* <Route path="/other" element={<Other />} /> */}
          </Routes>
        </main>

        <footer className="absolute bottom-0 right-0 p-12 mr-6 mb-15">
          <img
            src="/logos/favicon.ico"
            alt="Logo"
            className="w-[15vw] max-w-[250px] h-auto object-contain"
          />
          
        </footer>
      </Router>
    </div>
  );
}

export default App;